import React, { Component } from 'react';

export class features extends Component {
  constructor (props) {
    super(props);
    this.handleHover = this.handleHover.bind(this);
    this.beginningRef = React.createRef();
    this.state = {
      selectedSection: props.data ? props.data[0] : {},
      selectedStepIndex: 0,
      hovering: false,
      scrolled: false,
    };
  }

  featuresRef = React.createRef();
  componentDidMount () {
    window.addEventListener('scroll', this.trackScrolling);
    setInterval(() => {
      if (!this.state.hovering && this.state.scrolled) {
        const currentIndex = this.state.selectedStepIndex;
        if (currentIndex === 3) {
          this.moveTimeline(0);
        } else {
          this.moveTimeline(currentIndex + 1);
        }
      }
    }, 6000);
  }

  trackScrolling = () => {
    const currentScroll = window.scrollY;
    const targetScroll = this.beginningRef.current.offsetTop - 200;
    if (currentScroll > targetScroll) {
        this.setState({
            scrolled: true,
        })
    }
  }
  handleHover (i) {
    this.setState({
      selectedSection: this.selectedSection = this.props.data[i],
      selectedStepIndex: i,
      hovering: true
    });
  }

  moveTimeline (i) {
    this.setState({
      selectedSection: this.selectedSection = this.props.data[i],
      selectedStepIndex: i
    });
  }

  stopHover () {
    this.setState({
      hovering: false
    });
  }

  timelineCircleClass (i) {
    if (i > this.state.selectedStepIndex) {
      return 'hidden';
    } else {
      return 'shown';
    }
  }

  stepTextClass (i) {
    let stepClassName = 'step';
    if (i === this.state.selectedStepIndex) {
      stepClassName += ' active';
    }
    return stepClassName;
  }

  stepTextFill (i) {
    if (i === this.state.selectedStepIndex) {
      return '#3ac0c6ff';
    } else {
      return '#333333';
    }
  }

  render () {
    return (
      <div ref={this.featuresRef} id='features' className='text-center'>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 section-title' ref={this.beginningRef}>
            <h2 className='title'>How does it work?</h2>
          </div>
        </div>
        <svg width='197.89mm' height='27.145mm' id='timeline' version='1.1' viewBox='0 0 197.89 27.145' xmlns='http://www.w3.org/2000/svg'>
          <g transform='translate(-5.1332 -78.275)'>
            <g fontFamily='Raleway' fontSize='9.2877px' fontWeight='bold' letterSpacing='0px' strokeWidth='.096747' wordSpacing='0px'>
              <text transform='scale(.93025 1.075)' x='27.842623' y='97.854919' onMouseEnter={() => this.handleHover(0)} onMouseLeave={() => this.stopHover()} className={this.stepTextClass(0)} fill={this.stepTextFill(0)} style={{ lineHeight: '1.25' }} xmlSpace='preserve'><tspan x='27.842621' y='97.854919' fontWeight='800' text-align='center' textAnchor='middle'>CONNECT</tspan><tspan x='27.842623' y='109.46453' fontWeight='bold' /></text>
              <text transform='scale(.93025 1.075)' x='84.935371' y='97.615067' onMouseEnter={() => this.handleHover(1)} onMouseLeave={() => this.stopHover()} className={this.stepTextClass(1)} fill={this.stepTextFill(1)} style={{ lineHeight: '1.25' }} xmlSpace='preserve'><tspan x='84.935371' y='97.615067' fontWeight='800' text-align='center' textAnchor='middle'>CURATE</tspan><tspan x='84.935371' y='109.22468' fontWeight='bold' /></text>
              <text transform='scale(.93025 1.075)' x='141.74243' y='98.010574' onMouseEnter={() => this.handleHover(2)} onMouseLeave={() => this.stopHover()} className={this.stepTextClass(2)} fill={this.stepTextFill(2)} style={{ lineHeight: '1.25' }} xmlSpace='preserve'><tspan x='141.74243' y='98.010574' fontWeight='800' text-align='center' textAnchor='middle'>PRODUCE</tspan><tspan x='141.74243' y='109.62019' fontWeight='bold' /></text>
              <text transform='scale(.93025 1.075)' x='198.90005' y='97.7052' onMouseEnter={() => this.handleHover(3)} onMouseLeave={() => this.stopHover()} className={this.stepTextClass(3)} fill={this.stepTextFill(3)} style={{ lineHeight: '1.25' }} xmlSpace='preserve'><tspan x='198.90005' y='97.7052' fontWeight='800' text-align='center' textAnchor='middle'>PUBLISH</tspan><tspan x='198.90005' y='109.31481' fontWeight='bold' /></text>
            </g>
            <circle transform='rotate(90)' cx='83.912' cy='-77.895' r='5.1049' fill='none' opacity='.99824' stroke='#3ac0c6' strokeLinejoin='round' strokeWidth='1.0635' />
            <g stroke='#3ac0c6'>
              <circle transform='rotate(90)' cx='83.912' cy='-77.895' r='5.1049' fill='none' opacity='.99824' strokeLinejoin='round' strokeWidth='1.0635' />
              <g fill='none'>
                <circle transform='rotate(90)' cx='84.141' cy='-130.16' r='5.1049' opacity='.99824' strokeLinejoin='round' strokeWidth='1.0635' />
                <circle transform='rotate(90)' cx='84.33' cy='-182.43' r='5.1049' opacity='.99824' strokeLinejoin='round' strokeWidth='1.0635' />
                <path d='m72.802 84.315c-97.416 0 0 0 0 0z' strokeDasharray='3.70701423, 3.70701423' strokeWidth='.92675' />
                <circle transform='rotate(90)' cx='84.471' cy='-25.629' r='5.1049' opacity='.99824' strokeLinejoin='round' strokeWidth='1.0635' />
              </g>
              <circle transform='rotate(90)' className={this.timelineCircleClass(0)} cx='84.471' cy='-25.722' r='3.0216' fill='#3ac0c6' opacity='.99824' strokeLinejoin='round' strokeWidth='.6295' />
              <path d='m125.13 84.315c-97.249 0 0 0 0 0z' fill='none' strokeDasharray='3.70384054, 3.70384054' strokeWidth='.92596' />
              <path d='m177.45 84.315c-97.249 0 0 0 0 0z' fill='none' strokeDasharray='3.70384054, 3.70384054' strokeWidth='.92596' />
              <g fill='#3ac0c6' strokeLinejoin='round' strokeWidth='.6295'>
                <circle transform='rotate(90)' className={this.timelineCircleClass(1)} cx='83.873' cy='-77.868' r='3.0216' opacity='.99824' />
                <circle transform='rotate(90)' className={this.timelineCircleClass(2)} cx='84.166' cy='-130.19' r='3.0216' opacity='.99824' />
                <circle transform='rotate(90)' className={this.timelineCircleClass(3)} cx='84.312' cy='-182.37' r='3.0216' opacity='.99824' />
              </g>
            </g>
          </g>
        </svg>
        <div />
        <div className='row content'>
          <div className='col-md-5 steps'>
            <div className='row'>
              <h4 className='content-title'> {this.state.selectedSection.title ? this.state.selectedSection.title : 'Connect your news feed'} </h4>
            </div>
            <div className='row'>
              <p className='content-p'> {this.state.selectedSection.text ? this.state.selectedSection.text : 'Connect your news feed'} </p>
            </div>
          </div>
          <div className='col-md-7'>
            <img className='selectedImage img-fluid' src={this.state.selectedSection.image ? this.state.selectedSection.image : 'img/how_it_works/screen_1.jpg'} />
          </div>
        </div>
      </div>
    );
  }
}

export default features;
